import React from 'react';
import { Trans } from 'react-i18next';
import { BasicLink } from '@components/buttons/BasicLink/BasicLink.component';
import { PlcImg } from '@components/PlcImg/PlcImg.component';
import { Text } from '@components/Text/Text.component';
import { Breakpoint, useBreakpoint } from '@styles/breakpoints';
import { urlEnum } from '@utils/url';

import './CASectionPopUp.scss';

const CASectionPopUp = () => {
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint < Breakpoint.s;

  return (
    <section className="ca-sectionPopUp plc-mt-l">
      <div className="flex-logo">
        <PlcImg alt="" plcSrc={{ src: 'ca-logo', type: 'local' }} width={isMobile ? 35 : 50} />
      </div>

      <div className="flex-texte">
        <Text flavour="light" i18nKey="landing.ca-title" variant={isMobile ? 'h5' : 'h4'} />
        <Text flavour="light" variant="p">
          <Trans i18nKey="landing.ca-content" ns="landing">
            <Text flavour="yellow" tag="span" variant="p" />
          </Trans>
        </Text>
        <BasicLink
          as={urlEnum.proSavoirPlus}
          href={urlEnum.proSavoirPlus}
          isUnderlined
          textProps={{
            flavour: 'light',
            i18nKey: 'common.pro.savoir.plus',
            variant: isMobile ? 'h5' : 'h4',
          }}
        />
      </div>
    </section>
  );
};

export { CASectionPopUp };
